











































import { plainToInstance } from 'class-transformer'
import { snakeCase } from 'lodash'
import Vue from 'vue'
import { Component, Prop, VModel } from 'vue-property-decorator'

import {
  GroupedBotProperty,
  PropertyFieldType
} from '../../../../../../../../../../../BotProperties/components/Properties/types'
import { getPropertiesByType, prepareForFormulaInput, setPlaceholderPath } from '../../../../../../../../../../../BotProperties/utils'
import { SelectOptionData } from '../../../../../../../../../../../Pi/types'
import FormulaInput from '../../../../../../../../../../../f/FormulaInput.vue'
import BaseValue, { SetPropertyActionValue } from '../../../../../logic/PropertyConditionValues/BaseValue'
import CalculateValue from '../../../../../logic/PropertyConditionValues/CalculateValue'
import ConstantValue from "../../../../../logic/PropertyConditionValues/ConstantValue";
import NowValue from '../../../../../logic/PropertyConditionValues/NowValue'
import PropertyValue from '../../../../../logic/PropertyConditionValues/PropertyValue'
import { ConditionsNodeProps } from '../../../../../logic/types'
import PropertyConditionValueSettings from './PropertyConditionValueSettings.vue'
import PropertyConstantValueSettings from './PropertyConstantValueSettings.vue'

@Component({
  components: {
    PropertyConditionValueSettings,
    PropertyConstantValueSettings,
    FormulaInput
  },
  data() {
    return {
      CalculateValue,
      ConstantValue,
      BaseValue,
      NowValue,
      PropertyValue,
      snakeCase,
    }
  }
})
export default class ConditionSettings extends Vue {
  @VModel() conditionValue!: BaseValue

  @Prop() selectedProperty!: GroupedBotProperty

  @Prop() properties!: Array<GroupedBotProperty>

  @Prop() createProperty!: ConditionsNodeProps['createNewProperty']

  get formulaProperties(): Array<SelectOptionData> {
    const placeholdersWithPath = setPlaceholderPath(this.properties)
    const numProperties = getPropertiesByType(placeholdersWithPath, [ PropertyFieldType.Double, PropertyFieldType.Number ])

    return prepareForFormulaInput(this.$i18n, numProperties)
  }

  selectCompatibleAction(type: SetPropertyActionValue): void {
    switch(type) {
      case SetPropertyActionValue.Calculate:
        this.conditionValue = plainToInstance(CalculateValue,{ type, value: '' })
        break
      case SetPropertyActionValue.Constant:
        this.conditionValue = plainToInstance(ConstantValue, { type, value: '' })
        break
      case SetPropertyActionValue.Now:
        this.conditionValue = plainToInstance(NowValue, { type })
        break
      case SetPropertyActionValue.Property:
        this.conditionValue = plainToInstance(PropertyValue, { type, property_index: null, transform: null })
        break
    }
  }

  getCompatibleActions(property: GroupedBotProperty): Array<SetPropertyActionValue> {
    switch (property.type) {
      case PropertyFieldType.DateTime:
      case PropertyFieldType.Date:
      case PropertyFieldType.Time:
        return [
          SetPropertyActionValue.Property,
          SetPropertyActionValue.Constant,
          SetPropertyActionValue.Now,
        ]
      case PropertyFieldType.Email:
      case PropertyFieldType.Phone:
      case PropertyFieldType.String:
      case PropertyFieldType.URL:
        return [
          SetPropertyActionValue.Constant,
          SetPropertyActionValue.Property,
        ]
      case PropertyFieldType.Number:
      case PropertyFieldType.Double:
        return [
          SetPropertyActionValue.Property,
          SetPropertyActionValue.Constant,
          SetPropertyActionValue.Calculate,
        ]
      case PropertyFieldType.Flag:
      case PropertyFieldType.Files:
        return []
    }
  }
}
